import axios from 'axios'
import store from '../../store'

var newDate = new Date().toISOString().slice(0, 10).split('-')
var yearNow = parseInt(newDate[0])
if (yearNow <= 2500) { yearNow = yearNow + 543 }

const funcs = {
  getCCRp () {
    return new Promise((resolve, reject) => {
      axios
        // .get('/api/tabdb-desc/v1/catm/list/cc/?terminateDate=0', {})
        .get('./connectAPI/mis_forward.php?API=/api/tabdb-desc/v1/catm/list/cc/?terminateDate=0')
        .then(function (response) {
          var getList = []
          response.data.forEach(items => {
            const cc = items.code.toString().substring(0, 2)
            getList.push({
              'code': cc,
              'descWithCode': cc + ' : ' + items.description.thai,
              'desc': items.description.thai
            })
          })
          store.state.listCCG = getList
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getAAll (cc) {
    let ccSend = cc.toString().substring(0, 2)
    return new Promise((resolve, reject) => {
      axios
        // .get(`/api/tabdb-desc/v1/catm/list/cc/${ccSend}/aa/?terminateDate=0`)
        .get(`./connectAPI/mis_forward.php?API=/api/tabdb-desc/v1/catm/list/cc/${ccSend}/aa/?terminateDate=0`)
        .then(function (response) {
          var getList = []
          getList.push({ 'code': '', 'descWithCode': 'เลือกทั้งหมด', 'desc': 'เลือกทั้งหมด' })
          response.data.forEach(items => {
            let descThai = items.description.thai
            let descWithCode = items.code.toString().substring(2, 4) + ' : ' + descThai
            getList.push({
              'code': items.code.toString().substring(2, 4),
              'descWithCode': descWithCode,
              'desc': descThai
            })
          })
          store.state.listAAG = getList
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

}
export default funcs
